import { GetServerSideProps } from 'next';
import { getDefautServerProps } from 'server/getDefaultServerProps';
import { ExploreAppsPage } from 'modules/Apps/components/ExploreAppsPage';

const AppsPage: React.FC<{
  host: string;
}> = ({ host }) => {
  return <ExploreAppsPage host={host} />;
};

export const getServerSideProps: GetServerSideProps = async ({ params, req, res }) => {
  const host = req ? req.headers.host : 'clarifai.com';
  const defautServerProps = await getDefautServerProps({ params, req, res });
  return {
    props: {
      ...defautServerProps,
      host,
      trackEventProps: {
        eventName: 'Community Apps Page Viewed',
      },
      seoProps: {
        title: 'Explore state-of-the-art AI models',
        description: 'Jumpstart your AI solutions with pre-built models from Clarifai, leading AI providers and community contributors.',
      },
    },
  };
};

export default AppsPage;
